<div class="card">

    <div *ngIf="!propertyContract && !loading" fxLayout="row" fxLayoutAlign="center center">Error Loading Data</div>

    <div *ngIf="propertyContract" fxLayout="row" fxLayoutAlign="center center">

        <div class="container">
            <div fxLayout="row" fxLayoutAlign="space-between">
                <div style="font-size: x-large; font-weight: 400;" class="my-2">{{"property_details"|translate}}: <span
                        class="mx-2">{{propertyContract.contractID}}</span></div>

            </div>

            <div class=" flex flex-col sm:flex-row justify-items-center justify-between   mb-3">
                <div class="flex" style="font-size: large; color: rgb(109, 102, 102);">{{"property"|translate}}: {{
                    translateHelper.localize(propertyContract?.property?.name)}}</div>
            </div>
            <div class=" flex flex-col sm:flex-row justify-items-center justify-between   mb-3">
                <div class="flex" style="font-size: large; color: rgb(109, 102, 102);">{{"date_start"|translate}}:
                    {{propertyContract.startDate|date}} - {{"date_end"|translate}}:
                    {{propertyContract.endDate|date}}</div>

            </div>
            <div class=" flex flex-col sm:flex-row justify-items-center justify-between   mb-3">
                <div class="flex" style="font-size: large; color: rgb(109, 102, 102);">{{"contract_type"|translate}}: {{getContractType(propertyContract?.contractType)}}</div>

            </div>
            <div class=" flex flex-col sm:flex-row justify-items-center justify-between   mb-3">
                <div class="flex" style="font-size: large; color: rgb(109, 102, 102);">{{"balance"|translate}}: {{
                    propertyContract?.balance|currencyFormat}}</div>
            </div>

            <div>
                <mat-tab-group>
                    <mat-tab [label]="'invoices'|translate">
                        <div class="card-table">
                            <div class="table-responsive-sm">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>{{"ID"|translate}}</th>
                                            <th>{{"date"|translate}}</th>
                                            <th>{{"item_total"|translate}} </th>
                                            <th>{{"paid_price"|translate}}</th>
                                            <th>{{"balance"|translate}} </th>

                                        </tr>
                                    </thead>
                                    <tbody class="card-table__body card-table__body--merge-rows">
                                        <tr *ngFor="let item of invoices">
                                            <td>
                                                {{item.invoiceID}}

                                            </td>

                                            <td data-title="date">
                                                {{item.invoiceDate|date}}
                                            </td>

                                            <td data-title="item total">
                                                <span>{{item.totalPrice|currencyFormat}}</span>

                                            </td>
                                            <td data-title="paid price">
                                                <span>{{item.paidPrice|currencyFormat}}</span>
                                            </td>
                                            <td data-title="balance">
                                                <span>{{item.balance|currencyFormat}}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>

                        <div class="justify-end me-2 sm:flex flex-row">
                            <div class="float-left sm:items-start me-2 font-bold">
                                <div>{{"balance"|translate}}:</div>

                            </div>
                            <div class="float-right sm:items-end">
                                <div>{{ propertyContract?.balance|currencyFormat }}</div>



                            </div>
                        </div>
                    </mat-tab>


                    <mat-tab [label]="'receipts'|translate">
                        <div class="card-table">
                            <div class="table-responsive-sm">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>{{"ID"|translate}}</th>
                                            <th>{{"date"|translate}}</th>
                                            <th>{{"paid_price"|translate}}</th>


                                        </tr>
                                    </thead>
                                    <tbody class="card-table__body card-table__body--merge-rows">
                                        <tr *ngFor="let item of receipts">
                                            <td>
                                                {{item.receiptID}}

                                            </td>

                                            <td data-title="date">
                                                {{item.receiptDate|date}}
                                            </td>

                                            <td data-title="paidPrice">
                                                <span>{{item.totalPrice|currencyFormat}}</span>

                                            </td>

                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>
                    </mat-tab>



                    <mat-tab [label]="'property_contract'|translate" *ngIf="propertyContracts?.length > 0">
                        <div class="card-table">
                            <div class="table-responsive-sm">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>{{"ID"|translate}}</th>
                                            <th>{{"property"|translate}}</th>
                                            <th>{{"contract_type"|translate}}</th>
                                            <th>{{"date_start"|translate}}</th>
                                            <th>{{"date_end"|translate}}</th>
                                            <th>{{"last_invoice_date"|translate}}</th>
                                            <th>{{"last_invoicePrice"|translate}}</th>
                                            <th>{{"balance"|translate}}</th>


                                        </tr>
                                    </thead>
                                    <tbody class="card-table__body card-table__body--merge-rows">
                                        <tr *ngFor="let item of propertyContracts">
                                            <td>
                                                {{item.contractID}}

                                            </td>
                                            <td>
                                                {{translateHelper.localize(item.property?.name)}}

                                            </td>
                                            <td>
                                                {{getContractType(item.contractType)}}

                                            </td>

                                            <td >
                                                {{item.startDate|date}}
                                            </td>
                                            <td >
                                                {{item.endDate|date}}
                                            </td>
                                            <td >
                                                {{item.lastInvoiceDate|date}}
                                            </td>

                                            <td >
                                                <span>{{item.lastInvoicePrice|currencyFormat}}</span>

                                            </td>
                                            <td >
                                                <span>{{item.balance|currencyFormat}}</span>

                                            </td>

                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>
                    </mat-tab>


                </mat-tab-group>



            </div>

        </div>





    </div>
<br>
<br>

</div>
